import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

export const LOCALE_STORAGE_KEY = "erp_locale";
export const SUPPORTED_LOCALES = ["en", "ar"] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export function isRtlLocale(locale: string): boolean {
  return locale === "ar";
}

export function getStoredLocale(): AppLocale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && SUPPORTED_LOCALES.includes(stored as AppLocale)) {
    return stored as AppLocale;
  }
  return "en";
}

export function applyDocumentLocale(locale: string): void {
  const rtl = isRtlLocale(locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = rtl ? "rtl" : "ltr";
}

export async function setAppLocale(locale: AppLocale): Promise<void> {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  applyDocumentLocale(locale);
  await i18n.changeLanguage(locale);
}

const initialLocale = getStoredLocale();
applyDocumentLocale(initialLocale);

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLocale,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
